import { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { useNavigate, useLocation } from "react-router-dom";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import {
  capitalizeFirstLetter,
  deCapitalizeFirstLetter,
} from "../../util/Utils";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteRow from "../../components/DeleteRow";
import SearchComOff from "../../ContentManagement/firstPage/HomeOffer/SearchComOff";
import { useSnackbar } from "notistack";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import BrandSearchCom from "../../basic-information/brand/BrandSearchCom";
import { UseSupplierProduct } from "./UseSupplierProduct";

export default function SupplierBrand(props) {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const navigate = useNavigate();
  const { getSupplierBrandsByID, addSupplierProduct, deleteSupplierBrand } =
    UseSupplierProduct();
  const [myPcNew, setMyPcNew] = useState({
    page: 0,
    sortColumn: "Id",
    sortOrder: "Asc",
    forceRefresh: false,
  });
  const [name, setName] = useState("");
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [search, setSearch] = useState("");
  const [supplierBrandRes, setSupplierBrandRes] = useState();
  const [addBrand, setAddBrand] = useState(false);
  const [stateAdd, setStateAdd] = useState({
    supplierID: props.SupplierID,
    brandID: "",
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const refresh = () => {
    let page = myPcNew.page;
    if (page === 0) {
      page = 1;
    }
    setMyPcNew({ ...myPcNew, forceRefresh: !myPcNew.forceRefresh, page: page });
  };

  const updatePage = (page) => {
    setMyPcNew({ ...myPcNew, page: page, scrollTo: undefined });
  };
  const updateSort = (col, order) => {
    setMyPcNew({
      ...myPcNew,
      sortColumn: capitalizeFirstLetter(col),
      sortOrder: order,
      sorted: true,
    });
  };

  useEffect(() => {
    if (
      myPcNew.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getSupplierBrandsByID(props.SupplierID, myPcNew, (supplierBrands) => {
      setSupplierBrandRes(supplierBrands);
    });
  }, [props.SupplierID, myPcNew]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/supplierBrands/addSupplierBrand", {
      state: {
        myPcNew: myPcNew,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
      hide: true,
    },
    {
      field: "brandName",
      width: 250,
      align: "center",
      headerName: "نام برند",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.brandName}
          </Typography>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteState({
                show: true,
                name: cellValues.row.brandName,
                id: cellValues.row.id,
              });
            }}
          >
            <DeleteIcon sx={{ color: "MyColor.main" }} />
          </IconButton>
        );
      },
    },
    {
      field: "addBrand",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              // setScrollTo(undefined);
              location.state = null;
              setAddBrand(true);
            }}
          >
            <AddCircleIcon sx={{ color: "primary.main" }} />
          </IconButton>
        );
      },
    },
  ];

  return (
    <Dialog
      PaperProps={
        {
          // elevation: 1,
        }
      }
      sx={{ zIndex: 200 }}
      fullWidth
      open={props.showBrands}
      onClose={() => props.setShowBrands(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        sx={{ p: 1, px: 2 }}
        color="secondary"
        id="alert-dialog-title"
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {!addBrand ? (
            <Typography color="secondary" variant="subtitle2">
              لیست برندها
            </Typography>
          ) : (
            <Typography variant="subtitle2">برند را انتخاب کنید</Typography>
          )}
          {!addBrand ? (
            <IconButton
              onClick={() => {
                props.setShowBrands(false);
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ) : (
            <IconButton
              onClick={() => {
                setAddBrand(false);
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        {!addBrand ? (
          <Box sx={{ height: "30rem" }}>
            {supplierBrandRes ? (
              <DataGrid
                disableVirtualization
                localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
                columns={columns}
                pageSize={supplierBrandRes.pageCondition.pageCount}
                rows={supplierBrandRes.items}
                paginationMode="server"
                page={supplierBrandRes.pageCondition.page - 1}
                onPageChange={(page) => {
                  updatePage(page + 1);
                }}
                rowCount={supplierBrandRes.pageCondition.totalItemCount}
                enableRangeSelection={true}
                disableColumnMenu
                hideFooterSelectedRowCount
                components={{
                  Pagination: CustomPagination,
                }}
                componentsProps={{
                  pagination: {
                    scrollTo: myPcNew.scrollTo,
                    newFunc: newFunc,
                    nofab: true,
                    rowCount: supplierBrandRes.pageCondition.totalItemCount,
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: deCapitalizeFirstLetter(myPcNew.sortColumn),
                        sort: deCapitalizeFirstLetter(myPcNew.sortOrder),
                      },
                    ],
                  },
                  pagination: {
                    page: myPcNew.page,
                  },
                }}
                onSortModelChange={(model) => {
                  updateSort(
                    model[0].field,
                    model[0].sort == "asc" ? "asc" : "desc"
                  );
                }}
                sortingOrder={["desc", "asc"]}
                sortingMode="server"
              />
            ) : (
              <ProgressCom></ProgressCom>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              mt: 1,
            }}
          >
            <BrandSearchCom
              setName={setName}
              selectedBrandID={stateAdd.brandID}
              setter={setStateAdd}
              lvl1State={stateAdd}
            ></BrandSearchCom>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                sx={{ mr: 2 }}
                onClick={() => {
                  if (!stateAdd.brandID) {
                    enqueueSnackbar("برند را انتخاب کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  addSupplierProduct(stateAdd, () => {
                    setProgress(true);
                    props.callback(props.SupplierID);
                    getSupplierBrandsByID(
                      stateAdd.supplierID,
                      myPcNew,
                      (callback) => {
                        setSupplierBrandRes(callback);
                      }
                    );
                    setAddBrand(false);
                    setStateAdd({ ...stateAdd, brandID: "" });
                  });
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    if (!stateAdd.brandID) {
                      enqueueSnackbar("برند را انتخاب کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      return;
                    }
                    addSupplierProduct(stateAdd, () => {
                      setProgress(true);
                      props.callback(props.SupplierID);
                      getSupplierBrandsByID(
                        stateAdd.supplierID,
                        myPcNew,
                        (callback) => {
                          setSupplierBrandRes(callback);
                        }
                      );
                      setAddBrand(false);
                      setStateAdd({ ...stateAdd, brandID: "" });
                    });
                  }
                }}
              >
                ثبت
              </Button>
              <Button
                onClick={() => props.setShowBrands(false)}
                color="secondary"
                variant="outlined"
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"برند"}
          callback={() => {
            setProgress(true);
            deleteSupplierBrand(deleteState.id, () => {
              props.callback(props.SupplierID);
              getSupplierBrandsByID(props.SupplierID, myPcNew, (callback) => {
                setSupplierBrandRes(callback);
              });
            });
          }}
        ></DeleteRow>
      </DialogContent>
    </Dialog>
  );
}
